import axios from '@/bootstrap'
const endpoint = 'accounts'

export default class AccountsService {
  list(params) {
    return axios.get(`/api/${endpoint}`, params).then(res => res.data)
  }

  report(params) {
    return axios.get(`/api/${endpoint}/report`, params).then(res => res.data)
  }

  retrieve(id) {
    return axios.get(`/api/${endpoint}/${id}`).then(res => res.data)
  }

  create(data) {
    return axios.post(`/api/${endpoint}`, data).then(res => res.data)
  }

  import(data) {
    return axios.post(`/api/${endpoint}/import`, data).then(res => res.data)
  }

  update(id, data) {
    return axios.put(`/api/${endpoint}/${id}`, data).then(res => res.data)
  }

  delete(id) {
    return axios.delete(`/api/${endpoint}/${id}`).then(res => res.data)
  }
}
